<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" sm="12" xs="12" class="float-right">
        <button @click="mtdBack" type="button" class="btn btn-sm text-white float-right" style="background: #E46666">
          <i class="fas fa-hand-point-left"></i> Ir a Inicio
        </button>
      </CCol>
    </CRow>
    <div class="row" id="div_conte2">
      <div id="div_conte" class="col-md-10 mx-auto">
        <div class="bg-secondary text-white bg-opacity-10">
          <div class="text-center py-4 px-5" id="scroll-div">
            <div v-for="(buttonGroup, index) in groupedButtons" :key="index" class="row">
              <button v-for="(button, idx) in buttonGroup" :key="idx" class="div-button col m-2 p-2 text-white"
                @click="changePage(button.page)">
                {{ button.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "home",
  props: {
    // userRoles: {
    //   type: Array,
    //   required: true,
    // },
  },
  created() {
    this.showBead();
  },
  data() {
    return {
      verificBead: false,
      buttons: [
        { label: "COMPRA", page: "purchase" },
        { label: "VENTA", page: "sale" },
        { label: "VER STOCK", page: "stock" },
        { label: "AGENDAR SESSIONES", page: "session" },
        { label: "ENVIAR SALUDOS", page: "sendbirthay", companyIds: [10] },
        { label: "ENVIAR PROMOCIONES", page: "promotion", companyIds: [10, 11] },
        { label: "REGISTRO DE SUELDOS", page: "remuneration", companyIds: [10] },
      ],
    };
  },
  computed: {
    filteredButtons() {
      const companyId = this.$store.getters.get_company.id;

      return this.buttons.filter(button => {
        if (!button.companyIds) return true;
        return button.companyIds.includes(companyId);
      });
    },

    groupedButtons() {
      const groups = [];
      for (let i = 0; i < this.filteredButtons.length; i += 4) {
        groups.push(this.filteredButtons.slice(i, i + 4));
      }
      return groups;
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    changePage: function (page) {
      if (page == "sale" && !this.verificBead) {
        Swal.fire({
          title: "No hay caja aperturada",
          icon: "warning",
        });
      } else {
        this.$emit("changePage", page);
      }
    },
    hasRoles(roles) {
      return roles.some((role) => this.userRoles.includes(role));
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showBead/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.verificBead = response.data ? true : false;
            // this.bead = this.verificBead == true ? response.data : {};
          }
        })
        .catch((errors) => { });
    },
    mtdBack() {
      this.$emit('setView', 'home')
    },
  },
};
</script>

<style scoped>
#div_conte {
  border: 1.5px solid #00003a;
  padding: 0;
  margin: 40px 0;
}

.div-button {
  background: #00003a;
  border-radius: 15px;
  border: none;
}

#scroll-div {
  height: auto;
  overflow-y: scroll;
}

#scroll-div>div>button {
  height: 65px;
}

@media (max-width: 1320px) {
  #div_conte {
    border: 1.5px solid #00003a;
    padding: 0;
    margin: 60px 0;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {

  #div_conte {
    border: 1.5px solid #00003a;
    padding: 0;
    margin: 100px 0;
  }

  #scroll-div {
    height: 518px;
  }
}

@media (max-width: 768px) {
  #scroll-div>div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #div_conte2 {
    padding-left: 30px;
    padding-right: 30px;
  }

  #scroll-div>div>button {
    height: 44px;
    width: 100%;
    margin: 5px 0;
  }

  .container {
    font-size: 11px;
  }

  #scroll-div {
    height: 450px;
  }
}

@media (max-width: 415px) {
  #scroll-div>div>button {
    height: 40px;
    font-size: 12px;
  }
}
</style>